export const cilGrid = ["24 24","<path d='M21.021 2.229h-18.042c-0.414 0-0.75 0.336-0.75 0.75v0 18.042c0 0.414 0.336 0.75 0.75 0.75v0h18.042c0.414 0 0.75-0.336 0.75-0.75v0-18.042c0-0.414-0.336-0.75-0.75-0.75v0zM20.271 8.243h-4.514v-4.514h4.514zM9.743 14.257v-4.514h4.514v4.514zM14.257 15.757v4.514h-4.514v-4.514zM8.243 14.257h-4.514v-4.514h4.514zM9.743 8.243v-4.514h4.514v4.514zM15.757 9.743h4.514v4.514h-4.514zM8.243 3.729v4.514h-4.514v-4.514zM3.729 15.757h4.514v4.514h-4.514zM15.757 20.271v-4.514h4.514v4.514z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-grid.js
// module id = null
// module chunks = 